/**
 * Enum for each section.
 */
export enum Sections {
  SelectAccounts,
  YourApplication ,
  ReviewApplication,
  TermsAndDisclosure,
  VerifyIdentification,
  CreateLogin
}

/**
 * Enum for state of each section.
 */
export enum SectionStates {
  notStarted,
  notComplete,
  complete,
}

/**
 * Section status class for keeping state information on each section of main page.
 */
export class SectionStatus {
  constructor(public section : Sections, public description: string, public shortDescription:string, public status: SectionStates, public visible: boolean) {
  }
}
